import axios from 'axios';
import _ from 'lodash-es';

const state = {
  posts: [], // 投稿データ
  temporaryPosts: [], // 整形用投稿データ
  currentPosts: [], // 整形済み投稿データ
  pageCount: 0, // 総ページ数
  pageDivisionCount: 1, // ページ分割数
  perPage: 6, // 1ページあたりの表示数
  pageParameter: 1, // ページ数のパラメーター値
  conditionParameter: 'all', // 絞り込み条件のパラメーター値
  relativePath: '', // 現在のURL
  prefectureKeys: [
    'all',
    'hokkaido',
    'tohoku',
    'kanto',
    'chubu',
    'kansai',
    'chugoku',
    'shikoku',
    'kyushu',
    'okinawa',
  ],
  prefectureValues: {
    en: [
      'All',
      'Hokkaido',
      'Tohoku',
      'Kanto',
      'Chubu',
      'Kansai',
      'Chugoku',
      'Shikoku',
      'Kyushu',
      'Okinawa',
    ],
    ja: ['すべて', '北海道', '東北', '関東', '中部', '関西', '中国', '四国', '九州', '沖縄'],
    ko: [
      '모두',
      '홋카이도',
      '도호쿠',
      '간토',
      '주부',
      '간사이',
      '주고쿠',
      '시코쿠',
      '규슈',
      '오키나와',
    ],
    'zh-cn': ['全部', '北海道', '东北', '关东', '中部', '关西', '中国', '四国', '九州', '冲绳'],
    'zh-tw': ['全部', '北海道', '東北', '關東', '中部', '關西', '中國', '四國', '九州', '沖繩'],
    de: [
      'Alle',
      'Hokkaido',
      'Tohoku',
      'Kanto',
      'Chubu',
      'Kansai',
      'Chugoku',
      'Shikoku',
      'Kyushu',
      'Okinawa',
    ],
    fr: [
      'Tous',
      'Hokkaido',
      'Tohoku',
      'Kanto',
      'Chubu',
      'Kansai',
      'Chugoku',
      'Shikoku',
      'Kyushu',
      'Okinawa',
    ],
    th: [
      'ทั้งหมด',
      'ฮอกไกโด',
      'โทโฮคุ',
      'คันโต',
      'ชูบุ',
      'คันไซ',
      'ชูโงกุ',
      'ชิโกกุ',
      'คิวชู',
      'โอกินาว่า',
    ],
    id: [
      'Semua',
      'Hokkaido',
      'Tohoku',
      'Kanto',
      'Chubu',
      'Kansai',
      'Chugoku',
      'Shikoku',
      'Kyushu',
      'Okinawa',
    ],
    'zh-hk': ['所有', '北海道', '東北', '關東', '中部', '關西', '中國', '四國', '九州', '沖繩'],
    vi: [
      'Tất cả',
      'Hokkaido',
      'Tohoku',
      'Kanto',
      'Chubu',
      'Kansai',
      'Chugoku',
      'Shikoku',
      'Kyushu',
      'Okinawa',
    ],
  },
  prefectureSelectboxText: {
    en: 'Select Region',
    ja: '地域を選択する',
    ko: '지역 선택하기',
    'zh-cn': '选择地区',
    'zh-tw': '選擇地區',
    de: 'Region auswählen',
    fr: 'Sélection de la région',
    th: 'เลือกภูมิภาค',
    id: 'Pilih Wilayah',
    'zh-hk': '選擇地區',
    vi: 'Chọn vùng',
  },
  noResult: {
    en: 'No results returned for the filters selected.',
    ja: '選択した条件の結果はありません。',
    ko: '선택한 조건의 결과가 없습니다.',
    'zh-cn': '没有找到符合选择条件的结果。',
    'zh-tw': '找不到符合所選條件的結果。',
    de: 'Keine Ergebnisse für die ausgewählten Filter.',
    fr: 'Aucun résultat renvoyé pour les filtres sélectionnés.',
    th: 'ไม่มีผลลัพธ์สำหรับการกรองที่เลือก',
    id: 'Tidak ada hasil untuk filter yang dipilih.',
    'zh-hk': '沒有符合所選篩選器的結果。',
    vi: 'Không có kết quả nào cho bộ lọc đã chọn.',
  },
};

const getters = {
  // ページ分割数
  pageDivisionCount(state) {
    return Math.ceil(state.pageCount / state.perPage);
  },
  // ランダム出力
  randomPosts(state) {
    state.temporaryPosts = state.posts;
    const posts = _.cloneDeep(state.posts);
    const result = _.chain(posts)
      // 現在のページは除去する
      .reject(['url', state.relativePath])
      // 表示件数分だけ取得する
      .sampleSize(state.perPage)
      .value();
    state.currentPosts = result;
    state.pageCount = result.length;
    return result;
  },
  // 絞り込み出力
  filterPosts(state) {
    const posts = _.cloneDeep(state.posts);
    const hasCondition = state.conditionParameter !== '' && state.conditionParameter !== 'all';
    let result = [];
    if (hasCondition) {
      // 絞り込み条件（エリア）と記事のエリア（3つまで指定可能）が一致した記事を返す。
      result = _.filter(posts, function(post) {
        return post.areaValues.some(function(value) {
          return value === state.conditionParameter;
        });
      });
    } else {
      result = posts;
    }
    state.temporaryPosts = result;
    state.currentPosts = _.cloneDeep(state.temporaryPosts).slice(
      (state.pageParameter - 1) * state.perPage,
      (state.pageParameter - 1) * state.perPage + state.perPage,
    );
    state.pageCount = state.temporaryPosts.length;
    state.pageDivisionCount = Math.ceil(state.pageCount / state.perPage);
    return state.currentPosts;
  },
  // 最新（絞り込みなし）出力
  latestPosts(state) {
    const posts = _.cloneDeep(state.posts);
    const hasCondition = state.conditionParameter !== '' && state.conditionParameter !== 'all';
    let result = [];
    if (hasCondition) {
      // 絞り込み条件（エリア）と記事のエリア（3つまで指定可能）が一致した記事を返す。
      result = _.filter(posts, function(post) {
        return post.areaValues.some(function(value) {
          return value === state.conditionParameter;
        });
      });
    } else {
      result = posts;
    }
    state.temporaryPosts = result;
    state.currentPosts = _.cloneDeep(state.temporaryPosts).slice(
      (state.pageParameter - 1) * state.perPage,
      (state.pageParameter - 1) * state.perPage + state.perPage,
    );
    state.pageCount = state.temporaryPosts.length;
    state.pageDivisionCount = Math.ceil(state.pageCount / state.perPage);
    return state.currentPosts;
  },
};

const mutations = {
  getJson(state, data) {
    state.posts = data;
  },
  setRelativePath(state, data) {
    state.relativePath = data;
  },
  setPageParameter(state, data) {
    const page = data === '' ? 1 : data;
    state.pageParameter = page;
  },
  setConditionParameter(state, data) {
    const condition = data === '' ? 'all' : data;
    state.conditionParameter = condition;
  },
};

const actions = {
  // 表示ページの言語と一致したjsonを取得する
  getLangJson(context, lang) {
    axios.get(`/japan-travel-planner/common/js/itineraries/${lang}.json`).then(response => {
      context.commit('getJson', response.data);
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
